import type { APPLICANT_ATTRIBUTION } from 'cpool-constants';

import { getBaseIncomeDefaultValues } from './baseIncome';

export const getOtherIncomeDefaultValues = (attribution: APPLICANT_ATTRIBUTION) => ({
    ...getBaseIncomeDefaultValues(attribution),
    notiz: null,
});
